<template>
  <div class="container-home">
    <granary-title />
    <el-image-viewer
      v-if="showViewer"
      :initial-index="0"
      :on-close="onClose"
      :url-list="urlList"
    />
    <router-view />
    <!-- <page-content /> -->
    <map-content v-if="hasmap" />
  </div>
</template>

<script>
// 引入ElImageViewer组件
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
// const pageContent = () => import("./granary/page/index");
import granaryTitle from "@/components/granaryTitle";
const mapContent = () => import("./granary/map/map");
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showViewer: false,
      urlList: []
    };
  },
  computed: {
    ...mapGetters(["hasmap"])
  },
  components: { granaryTitle, mapContent, ElImageViewer },
  methods: {
    // 关闭图片预览
    onClose() {
      this.showViewer = false;
    }
  },
  mounted() {
    this.$bus.$on("ImageViewer", list => {
      if (list.length > 0) {
        this.showViewer = true;
        this.urlList = list;
      }
    });
  },
  destroyed() {
    this.$bus.$off("ImageViewer");
  }
};
</script>

<style lang="stylus" scoped>
// .container
//   width 100%
//   height 100vh
//   background url('~images/granary/bg.png') no-repeat center
//   background-size 100% 100%
//   position relative
//   overflow hidden
.container-home
    background url('~images/granary/bg.png') no-repeat center
    background-size 100% 100%
    height 100%
    width 100%
    position fixed
    top 0
    left 0
    overflow hidden
    >>>.el-image-viewer__close
        color white !important
</style>
